import { useState } from 'react';

export function useRerender() {
  const [forceRenderState, setForceRenderState] = useState<number>(0);
  const rerender = () => setForceRenderState(forceRenderState + 1);
  return rerender;
}
